<div class="card">
  <div class="card-body">
    <div class="mb-4 flex justify-between">
      <p class="card-title">API Key</p>
    </div>

    @if (loading) {
      <div class="skeleton h-28 rounded-md"></div>
    } @else if (apiKey) {
      <div class="overflow-x-auto rounded-lg border border-base-content/20">
        <table class="table table-zebra">
          <thead class="text-base font-medium">
            <tr>
              <td>API Key</td>
              <td>Created</td>
              <td class="w-10"></td>
            </tr>
          </thead>
          <tbody>
            <tr class="align-top">
              <td>
                <div class="flex items-center gap-2">
                  @if (shown) {
                    <app-eye-slash-icon
                      (click)="toggleShown()"
                      class="inline-block h-4 w-4 cursor-pointer"
                      title="Hide API key"
                    />
                  } @else {
                    <app-eye-icon
                      (click)="toggleShown()"
                      class="inline-block h-4 w-4 cursor-pointer"
                      title="Show API key"
                    />
                  }
                  <app-file-copy-icon
                    (click)="copyKey($event)"
                    class="inline-block h-4 w-4 cursor-pointer"
                    title="Copy API key"
                  />
                  @if (shown) {
                    <span class="font-mono text-sm">{{ apiKey.api_key }}</span>
                  } @else {
                    <span>{{ hiddenKeyString }}</span>
                  }
                </div>
              </td>
              <td>
                {{ apiKey.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
              </td>
              <td class="w-10">
                <div
                  class="h-6 w-6 cursor-pointer text-error hover:text-error/80"
                  (click)="showDeleteDialog()"
                >
                  <app-trash-icon></app-trash-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      @if (desApiKeyLinkLoading) {
        <div class="skeleton mt-3 h-6 w-80"></div>
      } @else if (desApiKeyLinkLoadError) {
        <p class="mt-3 text-error">{{ desApiKeyLinkLoadError }}</p>
      } @else if (desApiKeyLink?.lookup_error) {
        <p class="mt-3 text-error">{{ desApiKeyLink?.lookup_error }}</p>
      } @else if (showMultipleLinks) {
        <p class="alert alert-warning mt-3">{{ multipleLinksWarning }}</p>
      } @else if (showNotLinked) {
        <p class="alert alert-warning mt-3">{{ notLinkedMessage }}</p>
      }
    } @else {
      @if (error) {
        <p class="mb-3 text-error">{{ error }}</p>
      }
      <label class="form-control max-w-xl">
        <div class="label">
          <span class="label-text">API Key</span>
        </div>
        <div class="flex gap-2">
          <input
            type="text"
            class="input input-bordered w-full font-mono"
            placeholder="Enter API key"
            [(ngModel)]="newApiKey"
            [disabled]="creating || !tenantId"
            (keydown.enter)="addApiKey()"
          />
          <button
            type="button"
            class="btn btn-primary shrink-0"
            (click)="addApiKey()"
            [disabled]="!canAdd"
          >
            @if (creating) {
              <span class="loading loading-spinner loading-sm"></span>
            }
            Add
          </button>
        </div>
      </label>
    }
  </div>
</div>

<dialog class="modal" #deleteDialog>
  <div class="modal-box max-w-3xl p-8">
    <h3 class="text-lg font-bold">Confirm API Key Deletion</h3>

    <p class="mt-8 text-sm text-error">
      This deletion is permanent. Customer API access using this key will stop.
      Are you sure you want to delete this API key?
    </p>

    @if (deleteError) {
      <p class="mt-4 text-error">{{ deleteError }}</p>
    }

    <div class="mt-4 flex justify-end">
      @if (deleting) {
        <div class="loading loading-spinner mr-4"></div>
      }
      <button
        class="btn btn-error mr-4"
        (click)="deleteApiKey()"
        [disabled]="deleting"
      >
        Delete
      </button>
      <button class="btn btn-neutral" (click)="closeDeleteDialog()">
        Cancel
      </button>
    </div>
  </div>
</dialog>
